import React from 'react';

const MobileMenuSubItem = ({children}) => {
	return (
		<div className='mobile-links__item-sub-links' data-collapse-content>
            <ul className='mobile-links mobile-links--level--1'>
                {children}
            </ul>
		</div>
	);
};

export default MobileMenuSubItem;
